import request_py from '@/utils/request_py'

export function getPcVersion(params) {
    return request_py({
      url: '/pc_ext/version',
      method: 'get',
      params
    })
  }


  export function getPcBdVersion() {
    return process.env.VERSION
  }



// WEBPACK FOOTER //
// ./src/api/sys_version.js